module.exports = __webpack_public_path__ + "static/media/saturn.33663cc6.png";